import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import TableServerSideProvider from '~COMPONENTS/tableServerSide/TableServerSideContext';
import CatalogTypesList from './CatalogTypesList';
import CatalogTypeEdit from './CreateCatalogType';
import EditCatalogType from './EditCatalogType';

import { columnSortModifiersCatalogTypesList, columnFilterModifiersCatalogTypesList } from './columns';

const CatalogTypes = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <TableServerSideProvider
          tableId='catalogTypes'
          columnSortModifiers={columnSortModifiersCatalogTypesList}
          columnFilterModifiers={columnFilterModifiersCatalogTypesList}
        >
          <CatalogTypesList />
        </TableServerSideProvider>
      </Route>
      <Route key='new' exact path={`${path}/new`} component={CatalogTypeEdit} />
      <Route key='edit' path={`${path}/edit/:catalogTypeId`} component={EditCatalogType} />
    </Switch>
  );
};

export default CatalogTypes;
